export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13301.62c82475.jpg";